import DOMPurify from 'dompurify';
import { decodeHtmlEntities } from '~/lib/decodeHtmlEntities';

export const stripHtml = (html: string | undefined): string => {
  if (!html) return '';
  const normalized = html
    .replace(/\r?\n|\r/g, '')
    .replace(/<br\b[^>]*\/?>/gi, '\n')
    .replace(/&nbsp;|&#0*160;|&#x0*a0;/gi, ' ');
  const textOnly = DOMPurify.sanitize(normalized, { ALLOWED_TAGS: [] });
  return decodeHtmlEntities(textOnly).trimEnd();
};

export const sanitizeBodyForSave = (text: string): string => {
  if (!text) return '';
  const esc = (s: string) =>
    s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  return esc(text).replace(/\r?\n|\r/g, '<br>');
};

export const sanitizeTitleForSave = (title: string): string => {
  if (!title) return '';
  return title.trim();
};
